import { REPORT } from '@consts/reports';
import { BaseReport } from '../BaseReport';
import { useReportLoad } from '@hooks/useReportLoad';
import { count, countUnique, sum } from '@utils/summaries';
import { basicSort } from '@utils/sort';
import { styleDateRange } from '@utils/styles';

interface CutsByLocationProps {
    dateRange: { startDate: string; endDate: string };
}

export const CutsByLocation = ({ dateRange }: CutsByLocationProps) => {
    const { data, hasData, loading } = useReportLoad({
        reportType: REPORT.LOCATION_TOTAL_SUCCESSFUL_CUTS_BY_LOCATION_FOR_DATE_RANGE,
        params: { ...dateRange },
    });

    return (
        <BaseReport
            title={'Total Successful Cuts by Location'}
            description={
                'This table shows your total cut volume by location (successful, new sale cuts only) for the entire date range selected above.'
            }
            rangeText={styleDateRange([dateRange.startDate, dateRange.endDate])}
            loading={loading}
            hasData={hasData}
            tableOptions={{
                headers: ['Company Name', 'Reseller Name', 'Location Name', 'Successful Cuts', 'Rank'],
                data: data.map((item) => [item.companyName, item.resellerName, item.locationName, item.successfulCuts, item.rank]),
                summaries: [countUnique, countUnique, countUnique, sum, count],
                sort: [basicSort, basicSort, basicSort, basicSort, basicSort],
            }}
        />
    );
};
